import angular from 'angular';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

angular.module('flowingly.runner.maintenance').config(config);
config.$inject = ['$stateProvider'];

function config($stateProvider: angular.ui.IStateProvider) {
  $stateProvider.state(STATE_MAPPINGS.maintenanceFlows, {
    url: '/flows',
    params: { title: 'Maintenance - Flows' },
    views: {
      childcontent: {
        templateUrl:
          'Client/runner.maintenance/flows/runner.maintenance.flows.tmpl.html',
        controllerAs: '$ctrl',
        controller: 'maintenanceFlowsController'
      }
    }
  });
}
